import { useCallCenterRoutes } from "api/call-center/routes/hooks";
import { HighlightedRow } from "api/other/models";
import { UUID } from "api/types";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { ListDrawerWrapper } from "components/utils/drawer";
import { Loader } from "components/utils/loader";
import { ModuleList } from "components/utils/moduleList";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { callCenterRoutesListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { NoResults } from "components/utils/noResults";
import { useQuery } from "hooks";
import { useState } from "react";
import { handleMultipleRowsHighlight } from "utilities/handleMultipleRowsHighlight";
import { ListHeader } from "./components/ListHeader";
import { ListItem } from "./components/ListItem";
import { getSearch } from "./utils/getSearch";
import { Tab } from "api/call-center/routes/models";
import { RouteComponentProps } from "react-router";

export const RoutesList = ({ match }: RouteComponentProps<{ tab: Tab }>) => {
  const { tab } = match.params;
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query, tab });
  const { data: routes, error, isFetching, isLoading, pagination } = useCallCenterRoutes(search);
  const [highlightedRows, setHighlightedRows] = useState<HighlightedRow[]>([]);

  const noResults = !routes.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="callCenter" />
        <ListHeader />
      </div>
    );
  }

  const selectMutlipleItems = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: UUID | number,
    index: number,
    togglePanel: () => void,
  ) => {
    handleMultipleRowsHighlight(
      event,
      highlightedRows,
      id,
      index,
      setHighlightedRows,
      togglePanel,
      routes,
    );
  };

  return (
    <div className="pageContainer">
      {isFetching && <Loader module="callCenter" />}
      <ListHeader />
      <RightPanelHandler name="callCenterRoutes">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="trasy" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={callCenterRoutesListConfig.grid}
                  labels={callCenterRoutesListConfig.labels}
                />
                <ModuleListBody>
                  {routes.map((route, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={route.id}
                      route={route}
                      selectMutlipleItems={selectMutlipleItems}
                      togglePanel={togglePanel}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            {/* <RightPanel close={close} /> */}
            <InvoicePagination pagination={pagination} />
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
    </div>
  );
};
